import { 
  Waypoints,
  AlarmClockCheck,
  HandCoins
} from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const features = [
  { 
    icon: <Waypoints className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Emotional Connection",
    description: "Keeps parents engaged with caring, clear updates."
  },
  { 
    icon: <AlarmClockCheck className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Saves Teacher Time",
    description: "Automation removes repetitive messages and reduces manual work."
  },
  { 
    icon: <HandCoins className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Low Cost, High Impact",
    description: "Affordable subscription with visible benefits to parents and school metrics."
  }
];


export default function WhySchoolLoveAiPowred() {

    return (
        <Box
            badge={"Coming soon"}
            title={"Why Schools Love AI-Powered WhatsApp"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {features.map((member, index) => <MarktingCard key={"WhySchoolLoveAiPowred" + index} member={member} />)}
                    </div>
                </div>
            }
        />
    );
}